module.exports = __webpack_public_path__ + "img/info-circle.bd070636.svg";